<template>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" :destroy-on-close="true"
        :before-close="cancel">
        <el-transfer style="text-align: left; display: inline-block;width: 100%;" v-model="whiteList" filterable
            :titles="['人员列表', '白名单列表']" :format="{
                noChecked: '${total}',
                hasChecked: '${checked}/${total}'
            }" :data="personList">
        </el-transfer>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>

import { getConfigPage, editConfig } from "@/api/dilivery/sysconfig";
import { getPersonByType, getPersonById } from "@/api/dilivery/customer/person";
import { getDataInLocalStorage } from "@/utils/localStorage";

export default {
    name: "ContactWhiteList",
    props: ['showDialog'],
    data() {
        return {
            title: '编辑人员白名单',
            personList:[],
            whiteList:[],
            role:'',
            userData:{},
            form: {
                id:'',
                name: '',
                confKey: '',
                confValue: ''
            },
        }
    },
    mounted() {
        this.getWhiteList()
        this.getPersonList()
    },
    created() {
        this.userData = JSON.parse(getDataInLocalStorage('user'))
        this.role = getDataInLocalStorage('role')
    },
    methods: {
        getWhiteList () {
            getConfigPage({}, {}).then(res => {
                if (res.code === 200) {
                    const form = res.data.records.find(item => item.name === 'SYS_CONTACT_EDIT_WHITELIST')
                    if (form) {
                        this.whiteList = form.confValue.split(',')
                        this.form.id = form.id
                        this.form.name = form.name
                        this.form.confKey = form.confKey
                    }
                }
            }).catch(() => {
            })
        },
        getPersonList() {
            try {
                if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
                    getPersonByType('SALES', {}).then(res => {
                        if (res.code === 200) {
                            this.personList = res.data.map(item => {
                                return {
                                    key: item.uuid,
                                    label: item.name,
                                    disabled: false
                                }
                            }) 
                        }
                    }).catch(err => { })
                } else {
                    getPersonById(this.userData['personUuids'][0], {}).then(res => {
                        if (res.code === 200) {
                            this.personList = res.data.map(item => {
                                return {
                                    key: item.uuid,
                                    label: item.name,
                                    disabled: false
                                }
                            }) 
                        }
                    }).catch(err => { })
                }
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取人员信息失败');
            }
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handle() {
            this.form.confValue = this.whiteList.join(',')
            editConfig(this.form).then(res => {
                if (res.code === 200) {
                    this.$emit('submit', 'confirm')
                    this.$messageUi.success('修改成功')
                }
            }).catch(err => {
            })
        }
    }
}
</script>

<style scoped>
:deep(.el-transfer-panel) {
    width: 36%;
    height: 100%;
}
</style>
